// extracted by css-extract-rspack-plugin
export default {"empty-state":"lxNLdg","emptyState":"lxNLdg"};